import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useViewComplaintCount = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [complaintCount, setComplaintCount] = useState(0);

    const onViewComplaintCountError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            err?.response?.data?.message ?? 'Something went wrong while fetching complaint count.',
        );
    };

    const onViewComplaintCountSuccess = () => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        setComplaintCount(data?.totalRecords ?? 0);
    };

    const viewComplaintCount = () => {

        const url: HttpConfig = {
            url: 'ba/v1/drivers/verification/complaints?status=Pending&page=0&size=1&sort=complaintSubmittedAt%2CDESC',
            method: 'get',
        };

        request(url, onViewComplaintCountSuccess(), setLoading, onViewComplaintCountError);
    };

    return { viewComplaintCount, loading, complaintCount };
};

export default useViewComplaintCount;
